// Words for a staff access log entry (Backend/services/staffAccessLog.js),
// shared by the owner's Trust Center and the admin console's Access log.

export interface AccessEntry {
  investorId: string;
  actor: string;              // staff e-mail, or 'admin-console'
  actorKind: 'named' | 'shared-admin';
  sessionRef: string | null;
  action: 'viewed' | 'changed';
  area: string;
  path?: string;
  at: string;
}

const AREAS: Record<string, [string, string]> = {
  documents: ['Dokumente', 'documents'],
  leases: ['Mietverträge & Mieter', 'leases & tenants'],
  payments: ['Zahlungen & Zahlungspläne', 'payments & payment plans'],
  messages: ['Nachrichten', 'messages'],
  valuation: ['Bewertung & Berichte', 'valuation & reports'],
  maintenance: ['Instandhaltung', 'maintenance'],
  units: ['Einheiten', 'units'],
  profile: ['Profil & Konto', 'profile & account'],
  data: ['Daten', 'data'],
};

export function areaLabel(area: string, de: boolean) {
  const a = AREAS[area] || AREAS.data;
  return de ? a[0] : a[1];
}

export function actorLabel(e: AccessEntry, de: boolean) {
  if (e.actorKind === 'named') return e.actor;
  const ref = e.sessionRef ? ` (${de ? 'Sitzung' : 'session'} …${e.sessionRef})` : '';
  return (de ? 'Asset-Desk-Admin-Konsole, gemeinsamer Zugang' : 'Asset Desk admin console, shared login') + ref;
}

export function actionLabel(e: AccessEntry, de: boolean) {
  return e.action === 'changed' ? (de ? 'geändert' : 'changed') : (de ? 'angesehen' : 'viewed');
}

export function whenLabel(iso: string, de: boolean) {
  const d = new Date(iso);
  return isNaN(d.getTime()) ? '—' : d.toLocaleString(de ? 'de-DE' : 'en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}
